import React, {Component} from 'react';
import {Container, Row, Col, Button} from 'react-bootstrap';
import {TextInput, TextareaInput} from '../../../../components';
import AuthService from '../../../../services/auth-service/AuthService';
import DateUtil from '../../../../utils/DateUtil';

export default class NoteEditModal extends Component {
    constructor(props) {
        super(props);
        
        this.state = {
            header: '',
            description: '',
            staffId: '',
            updateDate: null,
            isActive: true,
            errorMessages: []
        };
    }
    
    componentDidMount() {
        if (this.props.note) {
            // Edit mode - populate existing note data
            this.setState({
                header: this.props.note.header || '',
                description: this.props.note.description || '',
                updateDate: this.props.note.updateDate,
                isActive: this.props.note.isActive,
            });
        } else {
            // New mode - set current user as staff
            const currentStaffId = AuthService.getStaffId();
            this.setState({
                staffId: currentStaffId,
                updateDate: new Date()
            });
        }
    }
    
    isCurrentUserCreator = () => {
        const currentStaffId = AuthService.getStaffId();
        return !this.props.note || this.props.note.staff.id === currentStaffId;
    };
    
    handleSave = () => {
        const {header, description, staffId} = this.state;
        
        // Validation
        const errors = [];
        if (!header?.trim()) {
            errors.push('Header is required');
        }
        if (!description?.trim()) {
            errors.push('Description is required');
        }
        
        if (errors.length > 0) {
            this.setState({errorMessages: errors});
            return;
        }
        
        const noteData = {
            noteKey: this.props.note?.noteKey,
            staffId: staffId,
            header: header.trim(),
            description: description.trim(),
        };
        
        this.props.onSave(noteData);
    };
    
    render() {
        const isCurrentUserCreator = this.isCurrentUserCreator();
        const isHistoryNote = !this.state.isActive;
        const isEditable = !this.props.readOnly && isCurrentUserCreator && !isHistoryNote;
        const isNewMode = this.props.newMode;
        
        return (
            <div style={{minWidth: '500px'}}>
                <Container className="InputModal">
                    {!isNewMode && (
                        <Row className="mb-2">
                            <Col xs={6} className="text-right">
                                <small className="text-muted">
                                    Last Edited: {DateUtil.formatDate(this.state.updateDate, 'DD/MM/YYYY HH:mm')}
                                </small>
                            </Col>
                            <Col xs={6} className="text-left">
                                <small className="text-muted">
                                    Staff: {this.props.note.staff.name}
                                </small>
                            </Col>
                        </Row>
                    )}
                    
                    <Row className="mb-3">
                        <Col xs={3} className="dim14-form-label">
                            Header
                        </Col>
                        <Col xs={9}>
                            <TextInput
                                value={this.state.header}
                                onChange={(value) => this.setState({header: value, errorMessages: []})}
                                disabled={!isEditable}
                                style={{width: '100%'}}
                                placeholder="Enter note header"
                            />
                        </Col>
                    </Row>
                    
                    <Row className="mb-3">
                        <Col xs={3} className="dim14-form-label">
                            Description
                        </Col>
                        <Col xs={9}>
                            <TextareaInput
                                value={this.state.description}
                                onChange={(value) => this.setState({description: value, errorMessages: []})}
                                disabled={!isEditable}
                                style={{width: '100%', minHeight: '100px'}}
                                placeholder="Enter note description"
                            />
                        </Col>
                    </Row>
                    
                    {this.state.errorMessages.length > 0 && (
                        <Row>
                            <Col xs={12}>
                                <div className="text-danger">
                                    {this.state.errorMessages.map((error, index) => (
                                        <div key={index}>{error}</div>
                                    ))}
                                </div>
                            </Col>
                        </Row>
                    )}
                    
                    {!isEditable && (
                        <Row>
                            <Col xs={12}>
                                <div className="text-info">
                                    <small>{!isCurrentUserCreator ? "You can only edit notes that you created." : "You cannot change the history."}</small>
                                </div>
                            </Col>
                        </Row>
                    )}
                    
                    {isEditable && (
                        <Row className="mt-3">
                            <Col xs={12} className="text-right">
                                <Button 
                                    variant="primary" 
                                    onClick={this.handleSave}
                                    disabled={this.state.errorMessages.length > 0}
                                >
                                    Save
                                </Button>
                            </Col>
                        </Row>
                    )}
                </Container>
            </div>
        );
    }
}